window.addEventListener('load', function() {
  if ('ontouchstart' in window) {
    var imageWrappers = document.querySelectorAll('.ProductItem__ImageWrapper');
    var previousWrapper;

    imageWrappers.forEach(function(wrapper) {
      var count = 0;
      var link = wrapper.parentNode.getAttribute('href') || wrapper.getAttribute('href');

      wrapper.addEventListener('click', function(event) {
        event.preventDefault();
      });

      wrapper.addEventListener('touchend', function(event) {
        event.stopPropagation();

        var img1 = wrapper.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
        var img2 = wrapper.querySelector('.ProductItem__Image--alternate');

        // Si hi ha una imatge anterior i aquesta no és l'actual, torna a mostrar la primera imatge de l'anterior
        if (previousWrapper && previousWrapper != wrapper) {
          var prevImg1 = previousWrapper.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
          var prevImg2 = previousWrapper.querySelector('.ProductItem__Image--alternate');

          prevImg1.style.opacity = 1;
          prevImg2.style.opacity = 0;
        }

        count++;

        if (count == 1) {
          img1.style.opacity = 0;
          img2.style.opacity = 1;
          previousWrapper = wrapper; // Estableix aquesta imatge com a imatge anterior
        } else if (count == 2) {
          window.location.href = link;
          count = 0;
        }
      });
    });

    document.addEventListener('touchend', function() {
      imageWrappers.forEach(function(wrapper) {
        var img1 = wrapper.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
        var img2 = wrapper.querySelector('.ProductItem__Image--alternate');

        img1.style.opacity = 1;
        img2.style.opacity = 0;
      });

      previousWrapper = null; // Restableix l'element anterior a null
    });
  }
});
